import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, Clock, Mail, MessageCircle,
  Calendar, Lock, Users, Trophy, Zap, AlertTriangle, Globe
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo18 from "@assets/logos_extracted/18.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://sgc.monvaki.com/?mid=282906_1667053";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Štědrý non-sticky uvítací bonus 250% až 20 000 Kč – nejvyšší bonusový poměr v nabídce",
  "Týdenní reload bonusy a cashbacky",
  "Responzivní mobilní stránky s čistým moderním rozhraním",
  "Gamifikace – Bonus Crab, mise a VIP program s 5 úrovněmi",
  "Nepřetržitá zákaznická podpora 24/7",
];

const cons = [
  "Výběry se neprovádějí o víkendech",
  "Možné zdržení při ověřování účtu (KYC)",
  "Omezené nástroje pro zodpovědné hraní",
  "Chybí mobilní aplikace – pouze responzivní web",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-48 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč (500 Kč pro aktivaci uvítacího bonusu)</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>500 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>E-peněženky / krypto:</span><span className={valueClass}>Obvykle do 24 hodin po schválení</span></div>
        <div className={rowClass}><span className={labelClass}>Karty / bankovní převod:</span><span className={valueClass}>2–5 pracovních dní (obvykle 2–3 dny)</span></div>
        <div className={rowClass}><span className={labelClass}>Víkendové výplaty:</span><span className={valueClass}>Nejsou zpracovávány</span></div>
        <div className={rowClass}><span className={labelClass}>Metody vkladu:</span><span className={valueClass}>Visa, Mastercard, Skrill, Neteller, MiFinity, eZeeWallet, bankovní převod, Paysafecard, Bitcoin, Ethereum, Litecoin, Ripple, USDT, Revolut, Klarna, CashtoCode, Jeton a další</span></div>
        <div className={rowClass}><span className={labelClass}>Metody výběru:</span><span className={valueClass}>Visa, Mastercard, Skrill, Neteller, bankovní převod, kryptoměny (Paysafecard a předplacené karty pro výběry nejsou dostupné)</span></div>
        <div className={rowClass}><span className={labelClass}>Poplatky kasina:</span><span className={valueClass}>Žádné (limity dle VIP a týdenního/měsíčního stropu)</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Celkový počet her:</span><span className={valueClass}>Více než 5 000 titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Video sloty, progresivní jackpoty, Megaways, bonusová kola</span></div>
        <div className={rowClass}><span className={labelClass}>Ruleta:</span><span className={valueClass}>Evropská, americká, francouzská – elektronická i živá verze</span></div>
        <div className={rowClass}><span className={labelClass}>Blackjack:</span><span className={valueClass}>Klasický, Multihand, VIP, rychlé verze, živý krupiér</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano – s vlastním sport bonusem</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>NetEnt, Pragmatic Play, Play'n GO, Microgaming, Evolution, Red Tiger, Yggdrasil, Quickspin, Push Gaming, ELK Studios, Betsoft, iSoftBet, Thunderkick, EGT (Amusnet), Playtech a další</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Dostupnost:</span><span className={valueClass}>24/7 – včetně víkendů a svátků</span></div>
        <div className={rowClass}><span className={labelClass}>Live chat:</span><span className={valueClass}>Ano – odpověď obvykle do několika minut</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@sgcasino.com</span></div>
        <div className={rowClass}><span className={labelClass}>FAQ:</span><span className={valueClass}>Přehledná sekce nápovědy na webu</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky podpory:</span><span className={valueClass}>Angličtina, němčina, finština, norština, francouzština, italština, polština, portugalština, maďarština, čeština, španělština</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok spuštění:</span><span className={valueClass}>2023</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Rabidi N.V.</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Curaçao</span></div>
        <div className={rowClass}><span className={labelClass}>Platformy:</span><span className={valueClass}>PC, mobilní prohlížeč (bez aplikace)</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Přijímané měny:</span><span className={valueClass}>Kč, EUR, USD, CAD, AUD, PLN, HUF, NOK, INR, BRL, JPY, NZD, TRY + kryptoměny</span></div>
        <div className={rowClass}><span className={labelClass}>VIP program:</span><span className={valueClass}>Ano – 5 úrovní</span></div>
        <div className={rowClass}><span className={labelClass}>Česká republika:</span><span className={valueClass}>Přístup povolen</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        {([
          ["Deposit limity:", "Nastavitelné v profilu"],
          ["Sebevyloučení:", "Ano"],
          ["KYC ověření:", "Povinné před výběrem – připravte dokumenty předem"],
          ["Nástroje:", "Omezené oproti EU regulovaným kasinům"],
          ["Věková hranice:", "18+"],
          ["Licence:", "Curaçao (ne česká regulace MF ČR)"],
        ] as [string, string][]).map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={valueClass}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function SgCasinoPage() {
  useSEO({ title: "SG Casino Recenze 2026 – Tisíce slotů a live hry | HrajBonus", description: "Nezávislá recenze SG Casino. Tisíce slotů, live kasino hry a uvítací bonus pro nové hráče. Rychlé výplaty a podpora v češtině. 18+",
  url: "https://hrajbonus.com/kasina/sg-casino", });

  const [activeTab, setActiveTab] = useState("platby");

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo18} alt="SG Casino logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Recenze Kasina SG Casino</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">9.0</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Bonusový poměr", value: "250%" },
                    { label: "Počet her",      value: "5 000+" },
                    { label: "Min. vklad",     value: "250 Kč" },
                    { label: "Min. výběr",     value: "500 Kč" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Non-sticky bonus</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">250% poměr – nejvyšší</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">VIP 5 úrovní</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Týdenní reload</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Čeština + Kč</span>
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Česká republika má přístup povolen · Přijímá Kč
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus (non-sticky)</div>
                  <div className="text-[#f5c518] font-black text-2xl leading-tight">250%</div>
                  <div className="text-white font-bold text-lg">až 20 000 Kč</div>
                  <div className="text-[#f5c518] font-semibold text-base">+ 250 free spinů</div>
                  <div className="text-white/50 text-xs mt-1">Wager 35× (vklad+bonus) · Wager 40× FS</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="SG Casino" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">9.0</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Recenze Kasina SG Casino</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  SG Casino vstoupilo na trh v roce 2023 pod hlavičkou skupiny Rabidi N.V. a hned zaujalo jedním z nejvyšších bonusových poměrů v oboru – 250% uvítací bonus až do výše 20 000 Kč. Platforma nabízí přes 5 000 her, čistý moderní design, propracovaný VIP program a nonstop podporu v češtině.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* About */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">Moderní kasino s nejvyšším bonusovým poměrem</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  SG Casino se odlišuje čistým moderním vzhledem s rychlým a intuitivním rozhraním. Tisíce her včetně živého kasina a jackpotových automatů jsou dostupné jak na počítači, tak na mobilním prohlížeči.
                </p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-5">
                  {[
                    { label: "250% bonus",         desc: "Nejvyšší bonusový poměr ze všech recenzovaných kasin" },
                    { label: "250 free spinů",     desc: "Nejvíce free spinů v uvítacím balíčku" },
                    { label: "VIP 5 úrovní",       desc: "Propracovaný věrnostní program s cashbackem a výhodami" },
                    { label: "Týdenní reload",     desc: "Pravidelné bonusy pro stálé hráče každý týden" },
                    { label: "Bonus Crab + mise",  desc: "Gamifikace a odměny za splnění herních výzev" },
                    { label: "Revolut + Klarna",   desc: "Unikátní platební metody nedostupné jinde" },
                  ].map(({ label, desc }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-1">{label}</div>
                      <div className="text-gray-600 text-xs leading-relaxed">{desc}</div>
                    </div>
                  ))}
                </div>

                <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm leading-relaxed">
                    SG Casino provozuje svou činnost na základě licence Curaçao. Nejde o licenci vydanou Ministerstvem financí ČR – právní ochrana pro české hráče se proto liší od lokálně regulovaných operátorů.
                  </p>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy &amp; Akce</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  SG Casino nabízí <strong>non-sticky (nelepivý) uvítací bonus</strong> s bonusovým poměrem 250% – nejvyšším ze všech kasin v naší databázi. Součástí balíčku je i sport bonus pro sázkové nadšence.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mb-5">
                  <div className="bg-[#f0f5ff] border border-[#003da5]/20 rounded-xl p-4">
                    <div className="text-[#c9960f] font-black text-2xl mb-0.5">250%</div>
                    <div className="text-[#003da5] font-bold text-base mb-1">až 20 000 Kč</div>
                    <div className="text-[#c9960f] font-semibold text-sm mb-2">+ 250 free spinů</div>
                    <div className="text-gray-400 text-xs space-y-0.5">
                      <div>Non-sticky · Wager 35× (vklad+bonus)</div>
                      <div>Wager free spiny 40× · Min. vklad 500 Kč</div>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-3">
                      <div className="text-gray-700 font-bold text-sm mb-0.5">Sport bonus</div>
                      <div className="text-gray-900 font-bold text-base">100% až 2 500 Kč</div>
                      <div className="text-gray-400 text-xs mt-1">Na první vklad do sportovní sekce</div>
                    </div>
                    <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-3">
                      <div className="text-gray-700 font-bold text-sm mb-0.5">Týdenní reload bonus</div>
                      <div className="text-gray-600 text-xs leading-relaxed">Pravidelné dobíjecí bonusy pro stálé hráče každý týden</div>
                    </div>
                    <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-3">
                      <div className="text-gray-700 font-bold text-sm mb-0.5">Cashback</div>
                      <div className="text-gray-600 text-xs leading-relaxed">Pravidelný cashback v rámci VIP programu</div>
                    </div>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                  <div className="font-bold text-green-800 text-sm mb-1.5">Co je non-sticky bonus?</div>
                  <p className="text-green-700 text-sm leading-relaxed">
                    U nelepivých bonusů jsou reálné výhry odděleny od bonusových prostředků. Pokud vyhrajete ze svého vlastního vkladu ještě před splněním wageru, tyto reálné výhry lze vybrat. Jde o výrazně hráč-přívětivější podmínky než u klasického sticky bonusu.
                  </p>
                </div>
              </div>

              {/* Games */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hry &amp; Poskytovatelé</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Celkový počet her překračuje 5 000 titulů napříč kategoriemi – od klasických automatů až po živé kasino a stolní hry. Katalog je pravidelně aktualizován o nové přírůstky.
                </p>
                <div className="grid sm:grid-cols-2 gap-3 mb-4">
                  {[
                    ["Výherní automaty",  "Video sloty, progresivní jackpoty, Megaways mechanika, bonusová kola"],
                    ["Ruleta",            "Evropská, americká, francouzská – elektronická i živá; speciální sázky a VIP limity"],
                    ["Blackjack",         "Klasický, Multihand, VIP, rychlé verze; RNG i živý krupiér"],
                    ["Sportovní sázení",  "Plnohodnotná sázková sekce s vlastním uvítacím bonusem"],
                  ].map(([label, val]) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-600 text-xs leading-relaxed">{val}</div>
                    </div>
                  ))}
                </div>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4">
                  <div className="font-bold text-[#003da5] text-xs mb-2">Populární poskytovatelé</div>
                  <div className="flex flex-wrap gap-1.5">
                    {["NetEnt", "Pragmatic Play", "Play'n GO", "Microgaming", "Evolution", "Red Tiger", "Yggdrasil", "Quickspin", "Push Gaming", "ELK Studios", "Betsoft", "iSoftBet", "Thunderkick", "EGT (Amusnet)", "Playtech"].map(p => (
                      <span key={p} className="bg-white border border-[#003da5]/15 text-gray-700 text-xs px-2.5 py-1 rounded-full font-medium">{p}</span>
                    ))}
                    <span className="text-gray-400 text-xs self-center">a další...</span>
                  </div>
                </div>
              </div>

              {/* VIP */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">VIP program, gamifikace a věrnostní výhody</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  SG Casino odměňuje stálé hráče propracovaným VIP programem s 5 úrovněmi, cashbackem, týdenními reload bonusy a herními misemi.
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-4">
                  {["Bronz", "Stříbro", "Zlato", "Platina", "Diamant"].map((tier, i) => (
                    <div key={tier} className={`rounded-xl p-2.5 text-center border ${i === 4 ? "bg-[#003da5] border-[#003da5] text-white" : "bg-[#f3f6fb] border-[#dde4ee] text-gray-700"}`}>
                      <div className="font-bold text-xs">{tier}</div>
                      <div className={`text-xs mt-0.5 ${i === 4 ? "text-white/70" : "text-gray-400"}`}>Úroveň {i + 1}</div>
                    </div>
                  ))}
                </div>
                <div className="grid sm:grid-cols-3 gap-3">
                  {[
                    { label: "Týdenní reload",   desc: "Pravidelné dobíjecí bonusy každý týden" },
                    { label: "Cashback",          desc: "Vrácení části prohraných sázek" },
                    { label: "Bonus Crab + mise", desc: "Herní výzvy s okamžitými odměnami" },
                  ].map(({ label, desc }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-sm mb-0.5">{label}</div>
                      <div className="text-gray-600 text-xs leading-relaxed">{desc}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební metody</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  SG Casino nabízí rozsáhlou škálu platebních metod. Unikátně jsou dostupné Revolut a Klarna, které většina online kasin nenabízí.
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5">
                  {[
                    { label: "Min. vklad (obecný)",  value: "250 Kč" },
                    { label: "Min. vklad (bonus)",   value: "500 Kč" },
                    { label: "Min. výběr",           value: "500 Kč" },
                    { label: "E-peněženky / krypto", value: "Do 24 hodin" },
                    { label: "Karty / bank. převod", value: "2–5 prac. dní" },
                    { label: "Víkendové výplaty",    value: "Nejsou zpracovávány" },
                  ].map(({ label, value }) => (
                    <div key={label} className={`rounded-xl p-3 ${label === "Víkendové výplaty" ? "bg-amber-50 border border-amber-200" : "bg-[#f3f6fb]"}`}>
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className={`font-bold text-xs ${label === "Víkendové výplaty" ? "text-amber-700" : "text-gray-900"}`}>{value}</div>
                    </div>
                  ))}
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-4">
                  <div className="flex items-start gap-2">
                    <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
                    <p className="text-amber-700 text-xs leading-relaxed">
                      <strong>Pozor:</strong> Výběry nejsou zpracovávány o víkendech. Paysafecard a předplacené karty nejsou pro výběry dostupné. Minimální výběr 500 Kč je vyšší než u většiny konkurentů.
                    </p>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Metody vkladu</div>
                    <div className="flex flex-wrap gap-1">
                      {["Visa", "Mastercard", "Skrill", "Neteller", "MiFinity", "eZeeWallet", "Paysafecard", "Revolut", "Klarna", "Jeton", "Bitcoin", "Ethereum", "USDT"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Metody výběru</div>
                    <div className="flex flex-wrap gap-1">
                      {["Visa", "Mastercard", "Skrill", "Neteller", "Bankovní převod", "Bitcoin", "Ethereum", "Litecoin", "USDT"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                    <div className="text-gray-400 text-xs mt-2">Paysafecard není dostupná pro výběry</div>
                  </div>
                </div>
              </div>

              {/* Support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Klientská podpora je dostupná nepřetržitě 24/7 – včetně víkendů a svátků. Nejrychlejší způsob kontaktu je živý chat, kde hráči obvykle obdrží odpověď během několika minut.
                </p>
                <div className="grid sm:grid-cols-3 gap-3 mb-4">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7 – odpověď do minut</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@sgcasino.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Info className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">FAQ sekce</div>
                      <div className="text-green-600 text-xs">Přehledná nápověda na webu</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo18} alt="SG Casino" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">SG Casino</div>
                      <div className="flex items-center gap-0.5">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">9.0/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus (non-sticky)</div>
                    <div className="text-[#c9960f] font-black text-xl">250%</div>
                    <div className="text-[#003da5] font-bold text-base">až 20 000 Kč</div>
                    <div className="text-[#c9960f] font-semibold text-sm">+ 250 free spinů</div>
                    <div className="text-gray-400 text-xs mt-0.5">Wager 35× · Min. vklad 500 Kč</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,   label: "Rok",            value: "2023" },
                      { icon: Globe,      label: "Provozovatel",   value: "Rabidi N.V." },
                      { icon: Lock,       label: "Licence",        value: "Curaçao" },
                      { icon: Gamepad2,   label: "Celkem her",     value: "5 000+" },
                      { icon: CreditCard, label: "Min. vklad",     value: "250 Kč (500 Kč pro bonus)" },
                      { icon: CreditCard, label: "Min. výběr",     value: "500 Kč" },
                      { icon: Zap,        label: "E-wallet výpl.", value: "Do 24 hodin" },
                      { icon: Trophy,     label: "VIP program",    value: "5 úrovní" },
                      { icon: Users,      label: "Sport bonus",    value: "100% až 2 500 Kč" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                  <div className="font-bold text-amber-800 text-xs mb-1.5">Pozor na víkendy</div>
                  <p className="text-amber-700 text-xs leading-relaxed">
                    Výběry nejsou zpracovávány o víkendech. Min. výběr 500 Kč je vyšší než u většiny kasin. KYC ověřte předem.
                  </p>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="sg-casino" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/alf-casino" className="text-[#003da5] hover:underline" data-testid="review-link-alf-casino">Alf Casino</a>
              {" · "}
              <a href="/kasina/bankonbet" className="text-[#003da5] hover:underline" data-testid="review-link-bankonbet">Bankonbet</a>
              {" · "}
              <a href="/kasina/stone-vegas" className="text-[#003da5] hover:underline" data-testid="review-link-stone-vegas">Stone Vegas</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
